export type MarginValue = string | number;

export type MarginType =
  | MarginValue
  | [MarginValue]
  | [MarginValue, MarginValue]
  | [MarginValue, MarginValue, MarginValue]
  | [MarginValue, MarginValue, MarginValue, MarginValue];

export const convertToMargin = (value: MarginType) => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return `${value}px`;
  if (Array.isArray(value)) return `${value.join('px ')}px`;
  return ''; // just for ts
};
